import requests from "@/common/fetch";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import { Result } from "../common";
import * as I from "./interface";

/** 删除子账号授权店铺 */
export const deleteSubAccountMallAuth = (
  params: I.AddSubAccountMallAuthParams
): Result<boolean> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/subAccount/authMall/delete",
      toUnderCase(params)
    )
  );
};

/** 添加子账号授权店铺 */
export const addSubAccountMallAuth = (
  params: I.DeleteSubAccountMallAuthParams
): Result<boolean> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/subAccount/authMall/add",
      toUnderCase(params)
    )
  );
};

/** 查询授权店铺列表 */
export const querySubAccountAuthMallList = (
  params: I.QuerySubAccountAuthMallListParams
): Result<I.QuerySubAccountAuthMallListResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/subAccount/authMall/list",
      toUnderCase(params)
    )
  );
};

/** 添加或删除子账号人群包管理权限 */
export const addOrDeletedSubAccountLabelAuth = (
  params: I.AddOrDeletedSubAccountLabelAuthParams
): Result<I.AddOrDeletedSubAccountLabelAuthResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/subAccount/updateLabelAuth",
      toUnderCase(params)
    )
  );
};

/** 查询子账号列表 */
export const querySubAccountList = (): Result<I.QuerySubAccountListResult> => {
  return toCamelCase(requests.post("/mmsapi/brandbank/subAccount/list"));
};

/** 查询子账户授权品牌列表 */
export function querySubAccountAuthBrandList(
  params: I.QuerySubAccountAuthMallListParams
): Result<I.SubAccountAuthBrandListResult> {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/subAccount/authBrand/list",
      toUnderCase(params)
    )
  );
}

/** 添加子账号授权品牌 */
export function addSubAccountBrandAuth(
  params: I.SubAccountBrandAuthParams
): Result<string> {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/subAccount/authBrand/add",
      toUnderCase(params)
    )
  );
}

/** 删除子账号授权品牌 */
export function deleteSubAccountBrandAuth(
  params: I.SubAccountBrandAuthParams
): Result<string> {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/subAccount/authBrand/delete",
      toUnderCase(params)
    )
  );
}
